import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromCarts from '../reducers/carts.reducer';

export const getCartState = createSelector(fromFeature.getShopifyState, (state: fromFeature.ShopifyState) => state.carts);

export const getCart = createSelector(getCartState, fromCarts.getCart);
export const getCartLoaded = createSelector(getCartState, fromCarts.getCartLoaded);
export const getCartLoading = createSelector(getCartState, fromCarts.getCartLoading);

export const getCartUpdate = createSelector(getCartState, fromCarts.getCartUpdate);

export const getCartLinesLoading = createSelector(getCartState, fromCarts.getCartLinesLoading);

export const getCartInitialized = createSelector(getCartState, fromCarts.getCartInitialized);
export const getCartInitializing = createSelector(getCartState, fromCarts.getCartInitializing);
export const getCartErrors = createSelector(getCartState, fromCarts.getCartErrors);

export const getLoadingDiscountUpdate = createSelector(getCartState, fromCarts.getLoadingDiscountUpdate);
export const getLoadedDiscountUpdate = createSelector(getCartState, fromCarts.getLoadedDiscountUpdate);
export const getDiscountUpdateErrors = createSelector(getCartState, fromCarts.getDiscountUpdateErrors);
